<template>
  <tab-bar class="tab-bar">
    <!-- 首页 -->
    <tab-bar-item path="/home">
      <img slot="item-icon" src="@assets/image/tabbarIcon/home-inactive.png" alt="加载失败" />
      <img slot="item-icon-active" src="@assets/image/tabbarIcon/home-active.png" alt="加载失败" />
      <div slot="item-text">首页</div>
    </tab-bar-item>
    <!-- 活动 -->
    <tab-bar-item path="/activity">
      <img slot="item-icon" src="@assets/image/tabbarIcon/activity-inactive.png" alt="加载失败" />
      <img slot="item-icon-active" src="@assets/image/tabbarIcon/activity-active.png" alt="加载失败" />
      <div slot="item-text">活动</div>
    </tab-bar-item>
    <!-- 折扣 -->
    <tab-bar-item class="cooperate" path="/dis-hot" v-if="isPlayer">
      <img slot="item-icon" src="@assets/image/tabbarIcon/discount-active.png" alt="加载失败" />
      <img slot="item-icon-active" src="@assets/image/tabbarIcon/discount-active.png" alt="加载失败" />
      <!-- <div>折扣</div> -->
    </tab-bar-item>
    <!-- 热门 -->
    <tab-bar-item class="cooperate" path="/dis-hot" v-else>
      <img slot="item-icon" src="@assets/image/tabbarIcon/hot-active.png" alt="加载失败" />
      <img slot="item-icon-active" src="@assets/image/tabbarIcon/hot-active.png" alt="加载失败" />
    </tab-bar-item>
    <!-- 礼包 -->
    <tab-bar-item path="/gift">
      <img slot="item-icon" src="@assets/image/tabbarIcon/gift-inactive.png" alt="加载失败" />
      <img slot="item-icon-active" src="@assets/image/tabbarIcon/gift-active.png" alt="加载失败" />
      <div slot="item-text">礼包</div>
    </tab-bar-item>
    <!-- 我的 -->
    <tab-bar-item path="/mine">
      <img slot="item-icon" src="@assets/image/tabbarIcon/mine-inactive.png" alt="加载失败" />
      <img slot="item-icon-active" src="@assets/image/tabbarIcon/mine-active.png" alt="加载失败" />
      <div slot="item-text">我的</div>
    </tab-bar-item>
  </tab-bar>
</template>

<script>
import TabBar from "@components/com/tabbar/TabBar";
import TabBarItem from "@components/com/tabbar/TabBarItem";
import { contTools } from "@/mixins/contMixins";

export default {
  name: "MainTabBar",
  mixins: [contTools],
  data() {
    return {};
  },
  watch: {},
  components: {
    TabBar,
    TabBarItem
  },
  computed: {
    isPlayer() {
      console.log(this.$store.state.wapConfig);
      let gId = this.$store.state.wapConfig.gid;
      if (gId == 1001 || gId == 1003) {
        // 折扣版
        // console.log("折扣版", gId);
        return true;
      } else {
        // 玩家版
        // console.log("玩家版", gId);
        return false;
      }
    }
  },
  created() {},
  methods: {
    onDis_Hot() {
      let id = this.isPlayer ? "2" : "3";
      this.$router.push({
        name: this.isPlayer ? "discount_hot" : "discount_hot",
        query: { partId: id }
      });
      this.$store.commit("setSctivityTypeId", id);
      this.$cookies.set("typeId", id);
    }
  }
};
</script>

<style  lang="less" scoped>
.cooperate {
  width: 20%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  // div {
  //   &:first-child {
  //     position: absolute;
  //     top: -50%;
  //     left: 50%;
  //     transform: translate(-50%, -50%);
  //     width: 2rem;
  //     img {
  //       .img() {
  //         width: 100%;
  //       }
  //       // height: 56px;
  //     }
  //   }
  // }

  div {
    font-size: 12px;
    color: #666;
    // font-weight: 700;
  }
}
</style>
